module.exports = __webpack_public_path__ + "r-8a5296c4d804086094b22d83e25e0f99.png";